import { render, staticRenderFns } from "./BlocoServidorDeEmail.vue?vue&type=template&id=7d56a9d8&scoped=true&"
import script from "./BlocoServidorDeEmail.vue?vue&type=script&lang=ts&"
export * from "./BlocoServidorDeEmail.vue?vue&type=script&lang=ts&"
import style0 from "./BlocoServidorDeEmail.vue?vue&type=style&index=0&id=7d56a9d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d56a9d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VExpandTransition,VRow,VSubheader,VSwitch,VTab,VTabItem,VTabs,VTabsItems,VTextField})
